import React, { Component } from 'react';
import CurrencyFormat from 'react-currency-format';

const currencyFormatParams = {
    displayType: 'text',
    decimalScale: 2,
    fixedDecimalScale: true,
    thousandSeparator: true,
    prefix: '$'
};
export class Currency extends Component {
    static displayName = Currency.name;

    constructor(props) {
        super(props)

      
    }

    render() {
        var value = 0;
        if (this.props.value) {
            value = this.props.value;
        }

        return (<CurrencyFormat value={value} {... currencyFormatParams} />);
    }
}